import { Injectable } from '@angular/core';
import { RestService, Rest, ABP } from '@abp/ng.core';
import { AppModuleManagement } from '../models';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AppTerminalSettingService {
    apiName = 'TerminalManagement';
    constructor(private rest: RestService) { }

    bindModules(body: AppModuleManagement.BindModulesRequest): Observable<null> {
        const request: Rest.Request<AppModuleManagement.BindModulesRequest> = {
            method: 'PUT',
            url: `/api/TerminalManagement/AppTerminalSettings/bind-modules`,
            body,
        };

        return this.rest.request<AppModuleManagement.BindModulesRequest, null>(request, {
            apiName: this.apiName,
        });
    }

    unBindModules(body: AppModuleManagement.BindModulesRequest): Observable<null> {
        const request: Rest.Request<AppModuleManagement.BindModulesRequest> = {
            method: 'PUT',
            url: `/api/TerminalManagement/AppTerminalSettings/unbind-modules`,
            body,
        };

        return this.rest.request<AppModuleManagement.BindModulesRequest, null>(request, {
            apiName: this.apiName,
        });
    }

    bindUsers(body: AppModuleManagement.BindUsersRequest): Observable<null> {
        const request: Rest.Request<AppModuleManagement.BindUsersRequest> = {
            method: 'PUT',
            url: `/api/TerminalManagement/AppTerminalSettings/bind-users`,
            body,
        };

        return this.rest.request<AppModuleManagement.BindUsersRequest, null>(request, {
            apiName: this.apiName,
        });
    }

    unBindUsers(body: AppModuleManagement.BindUsersRequest): Observable<null> {
        const request: Rest.Request<AppModuleManagement.BindUsersRequest> = {
            method: 'PUT',
            url: `/api/TerminalManagement/AppTerminalSettings/unbind-users`,
            body,
        };

        return this.rest.request<AppModuleManagement.BindUsersRequest, null>(request, {
            apiName: this.apiName,
        });
    }

    getTerminalSetting(terminalId: string): Observable<AppModuleManagement.AppTerminalSettingItem> {
        const request: Rest.Request<null> = {
            method: 'GET',
            url: `/api/TerminalManagement/AppTerminalSettings/${terminalId}`,
        };

        return this.rest.request<null, AppModuleManagement.AppTerminalSettingItem>(request, { apiName: this.apiName });
    }
}
